module.exports = __webpack_public_path__ + "media/images/pic/wsjj-team-2c0604494e652d1b07be4dd482d25c7b.webp";